import React, { useState, useEffect } from 'react';
import NineSlice from './components/NineSlice';
import LearningMap from './components/LearningMap';
import MissionDetail from './components/MissionDetail';
import UnitOverview from './components/UnitOverview';
import KeyInsights from './components/KeyInsights';
import './App.css';

function App() {
  const [data, setData] = useState(null);
  const [view, setView] = useState('map');
  const [selectedMission, setSelectedMission] = useState(null);

  useEffect(() => {
    fetch('/guide-data.json')
      .then(res => res.json())
      .then(setData)
      .catch(err => console.error('Failed to load guide data:', err));
  }, []);

  if (!data) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
        <p>학습 가이드를 불러오는 중...</p>
      </div>
    );
  }

  const handleMissionClick = (mission) => {
    setSelectedMission(mission);
    setView('mission');
  };

  const tabs = [
    { id: 'map', label: '학습 맵' },
    { id: 'overview', label: '단원개요' },
    { id: 'insights', label: '핵심 인사이트' },
  ];

  return (
    <div className="game-app">
      <header className="game-header">
        {/* 타이틀 배너 — 9-Slice Banner */}
        <NineSlice preset="bannerTitle" className="title-banner" style={{ width: 420, height: 80 }}>
          <span className="title-text">
            {data.unit.name.replace('1단원: ', '')} 도장깨기
          </span>
        </NineSlice>

        {/* 탭 버튼 — 9-Slice Buttons */}
        <nav className="game-nav">
          {tabs.map(tab => (
            <NineSlice
              key={tab.id}
              preset={view === tab.id ? 'blueButtonPressed' : 'blueButton'}
              className={`game-tab ${view === tab.id ? 'game-tab-active' : ''}`}
              style={{ width: 160, height: 50, cursor: 'pointer' }}
              onClick={() => setView(tab.id)}
            >
              <span className="tab-label">{tab.label}</span>
            </NineSlice>
          ))}
        </nav>
      </header>

      <main className="game-main">
        {view === 'map' && (
          <LearningMap missions={data.missions} onMissionClick={handleMissionClick} />
        )}
        {view === 'mission' && selectedMission && (
          <MissionDetail
            mission={selectedMission}
            allMissions={data.missions}
            keyItemsTemporal={data.keyItemsTemporal}
            onBack={() => setView('map')}
            onMissionChange={(m) => setSelectedMission(m)}
          />
        )}
        {view === 'overview' && <UnitOverview data={data} />}
        {view === 'insights' && <KeyInsights data={data} />}
      </main>
    </div>
  );
}

export default App;
